import { GameObjectEvent } from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import Game from '../../../Game';
import { CardType } from '../../Level/Card/CardType';
import { Anim } from '../../../System/Animation/AnimationHelper';
import { FTUXType } from '../../../Player/PlayerProperty/Progress/FTUXType';
import { LevelActions } from '../../../State/Level/LevelActions';
import { IGameState } from '../../../State/Game/IGameState';
import { FTUXStateHelper } from 'State/Game/FTUX/FTUXStateHelper';
import { LevelHudLayout } from 'Layouts/LevelHud/LevelHudLayout';
import TextComponent from 'Component/Render/Text';
import { MathHelper } from 'Utility/MathHelper';
import TransformComponent from 'Component/Transform';
import { Layout } from 'Utility/layout/createLayout';

type GoldBarProps = {
    layout: any;
}

export default class GoldBar {
    private readonly layout: any;
    private goldCardsTotal: number | null = null;
    private ftuxInfoWiggleDelay: number = 1000;
    private fullProgressScaleX: number;

    constructor(props: GoldBarProps) {
        this.layout = props.layout;
        this.fullProgressScaleX = this.layout.goldBarProgress.getComponent(TransformComponent).scale.x;
        this.layout.goldBarProgress.getComponent(TransformComponent).scale.x = 0;

        this.layout.goldBarContainer.on(
            GameObjectEvent.SELECTED,
            () => LevelActions.showGoldCardTutorial(),
        );

        if (FTUXStateHelper.isFtuxCompleted(Game.store.getState().playerState, FTUXType.GOLD_CARD)) {
            this.layout.goldBarInfoText.getComponent(Renderable).visible = false;
        } else {
            Game.ticker.setTimeout(this.wiggleFTUXInfoIcon, this.ftuxInfoWiggleDelay);
        }
    }

    public handleStateChanged(state: IGameState) {
        const inPlayGoldCardsAmount = state.levelState.cardsState.inPlay.filter((cardID: string) => {
            return state.levelState.cardsState.cards[cardID].type === CardType.gold;
        }).length;
        this.goldCardsTotal = this.goldCardsTotal ?? inPlayGoldCardsAmount;

        const collectedAmount = this.goldCardsTotal - inPlayGoldCardsAmount;
        const percent = MathHelper.clamp(collectedAmount / this.goldCardsTotal, 0, 1);
        this.setGoldCardProgress(percent);
        this.layout.goldBarText.getComponent(TextComponent).text = `${collectedAmount}/${this.goldCardsTotal}`;
    };

    private setGoldCardProgress(percent: number): void {
        const targetScale = this.fullProgressScaleX * percent;
        const duration = (targetScale - this.layout.goldBarProgress.getComponent(TransformComponent).scale.x) * 4000;
        Anim(this.layout.goldBarProgress, { scaleX: targetScale, duration: Math.max(1, duration) });
    }

    private wiggleFTUXInfoIcon = (): void => {
        if (this.layout.goldBarContainer.destroyed) return;

        Anim(this.layout.goldBarInfoText, { angle: [-30, 30, -30, 30], duration: 1000 });
        this.ftuxInfoWiggleDelay = Math.min(10000, this.ftuxInfoWiggleDelay + 1000);
        Game.ticker.setTimeout(this.wiggleFTUXInfoIcon, this.ftuxInfoWiggleDelay);
    };
}
